import {
  Body,
  Button,
  Heading,
  VStack,
  useBreakpointValue,
} from '@hover/blueprint';
import React from 'react';

import { useProTranslate } from '../hooks';

const HeroSection = () => {
  const t = useProTranslate();
  const { heading, description } = useBreakpointValue({
    base: {
      heading: t('header.mobile'),
      description: t('subHeader.mobile'),
    },
    tablet: {
      heading: t('header.tablet'),
      description: t('subHeader.mobile'),
    },
  });
  return (
    <VStack
      alignItems={{ base: 'flex-start', tablet: 'center' }}
      pb={{ base: 900, tablet: 950 }}
      pt={{ base: 800, tablet: 900 }}
      px={{ base: 500, tablet: undefined }}
    >
      <Heading
        alignSelf="center"
        margin="0px"
        noOfLines={2}
        size={{ base: 500, tablet: 800 }}
        textAlign={{ base: 'left', tablet: 'center' }}
        width={{ base: '100%', tablet: 800 }}
      >
        {heading}
      </Heading>
      <Body
        marginBottom={{ base: 500, tablet: 600 }}
        noOfLines={2}
        textAlign={{ base: 'left', tablet: 'center' }}
        textColor="neutral.600"
        width={{ base: '100%', tablet: 800 }}
      >
        {description}
      </Body>
      <Button size="large">{t('tryItWithYourPlace')}</Button>
    </VStack>
  );
};

export { HeroSection };
